import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./styles.css";

const container = document.getElementById("root");
if (!container) {
  throw new Error("index.html is missing its #root element");
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

// Installable app: Android Chrome wants a manifest and (on older builds) a service
// worker before it offers "Install app". The worker caches only the shell and hashed
// bundles — every score response still comes from the network, sw.js notwithstanding.
// Registration is a secure-context-only power; a plain-http deployment simply stays a
// website instead of failing quietly in the console.
if ("serviceWorker" in navigator && window.isSecureContext) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch(() => undefined);
  });
}
